import { suppliersApi } from './api';
import { toast } from '../components/Toast';

// "סמן את הספק" on the delivery-note warning chip, shared by the upload and
// document screens. No confirm: the flag is reversible on ניהול ספקים.
// `setSuppliers` is the page's supplier-list setter — flipping the flag there
// is what makes the chip disappear.
export async function markSupplierDeliveryNotes(supplierId, setSuppliers) {
  try {
    await suppliersApi.markDeliveryNotes(supplierId);
    setSuppliers(list => list.map(s => (String(s.id) === String(supplierId) ? { ...s, uses_delivery_notes: 1 } : s)));
    toast('הספק סומן כעובד עם תעודות משלוח');
  } catch (err) {
    toast(err.response?.data?.error || 'שגיאה בסימון הספק', 'error');
  }
}
